export default "__VITE_ASSET__iCeExX9$__"